import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import {
  AppUpdateService,
  ClientDetailsApiInterceptor,
  GeneralApiHttpInterceptor,
  TranslationLoaderFactory,
} from '@monorepo/services';
import { LoggerModule, NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { NgxPrintModule } from 'ngx-print';
import { environment } from '../environments/environment';
import { NavigationService } from '../guard/navigation.service';
import { ReduxStoreModule } from '../redux-store';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MarkdownModule } from 'ngx-markdown';
import { Zip } from '@ionic-native/zip/ngx';

@NgModule({
  declarations: [AppComponent],
  imports: [
    IonicStorageModule.forRoot({
      name: '__userDataBase',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('mm');
        },
        deps: [HttpClient],
      },
    }),
    IonicModule.forRoot(),
    AppRoutingModule,
    ReduxStoreModule,
    HttpClientModule,
    NgxPrintModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      serverLogLevel: NgxLoggerLevel.ERROR,
    }),
    MarkdownModule.forRoot(),
  ],
  providers: [
    {
      provide: 'environment',
      useValue: environment,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    NavigationService,
    NGXLogger,
    InAppBrowser,
    FileOpener,
    { provide: 'Zip', useClass: Zip },
    { provide: HTTP_INTERCEPTORS, useClass: ClientDetailsApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GeneralApiHttpInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (appUpdateService: AppUpdateService) => () => appUpdateService.init('Maintaini8'),
      deps: [AppUpdateService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
